import gql from 'graphql-tag';

/**
 * Mutation to request a presigned S3 URL for uploading an inspection photo.
 * Returns the upload URL, photoId, remote access URL, and expiry time.
 */
export const requestInspectionPhotoUploadUrlMutation = gql`
  mutation RequestInspectionPhotoUploadUrl(
    $input: RequestPhotoUploadUrlInput!
  ) {
    requestInspectionPhotoUploadUrl(input: $input) {
      url
      photoId
      remoteUrl
      expiresAt
    }
  }
`;
